import { useQuery } from '@apollo/client';
import { GET_CART } from 'mocks/queries';
import useZipCode from 'global-state/zipCode/useZipCode';

const useCartAndToken = () => {
  const zipCode = useZipCode();
  const { data, refetch } = useQuery(GET_CART, {
    fetchPolicy: 'cache-and-network',
    variables: { zipCode },
  });

  const cart = data?.getCart?.cart;
  const token = data?.getCart?.cart_token;

  return { cart, refetch, token };
};

export default useCartAndToken;
